import {
  uaLimitedReleaseDetailConstants,
  createUALimitedReleaseDetailConstants,
  editUALimitedReleaseDetailConstants,
  addTargetUALimitedReleaseDetailConstants,
  removeTargetUALimitedReleaseDetailConstants,
  activateUALimitedReleaseDetailConstants,
  deactivateUALimitedReleaseDetailConstants,
  deleteUALimitedReleaseDetailConstants,
} from "../_redux-constants";
import { uaLimitedReleasesDetailService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getUALimitedReleaseDetail(queryParams) {
  function getUALimitedReleaseDetailLoad() {
    return {
      type: uaLimitedReleaseDetailConstants.UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function getUALimitedReleaseDetailSuccess(data) {
    return {
      type: uaLimitedReleaseDetailConstants.UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function getUALimitedReleaseDetailFailure(error) {
    return {
      type: uaLimitedReleaseDetailConstants.UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getUALimitedReleaseDetailLoad());
    return uaLimitedReleasesDetailService
      .getUALimitedReleaseDetail(queryParams)
      .then(
        (data) => {
          dispatch(getUALimitedReleaseDetailSuccess(data));
        },
        (error) => {
          dispatch(getUALimitedReleaseDetailFailure(error?.toString()));
        }
      );
  };
}

function createUALimitedReleaseDetail(requestBody, queryParams) {
  function createUALimitedReleaseDetailLoad() {
    return {
      type: createUALimitedReleaseDetailConstants.CREATE_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function createUALimitedReleaseDetailSuccess(data) {
    return {
      type: createUALimitedReleaseDetailConstants.CREATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function createUALimitedReleaseDetailFailure(error) {
    return {
      type: createUALimitedReleaseDetailConstants.CREATE_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .createUALimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createUALimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editUALimitedReleaseDetail(requestBody, queryParams) {
  function editUALimitedReleaseDetailLoad() {
    return {
      type: editUALimitedReleaseDetailConstants.EDIT_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function editUALimitedReleaseDetailSuccess(data) {
    return {
      type: editUALimitedReleaseDetailConstants.EDIT_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function editUALimitedReleaseDetailFailure(error) {
    return {
      type: editUALimitedReleaseDetailConstants.EDIT_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .editUALimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editUALimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetUALimitedReleaseDetail(requestBody, queryParams) {
  function addTargetUALimitedReleaseDetailLoad() {
    return {
      type: addTargetUALimitedReleaseDetailConstants.ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function addTargetUALimitedReleaseDetailSuccess(data) {
    return {
      type: addTargetUALimitedReleaseDetailConstants.ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function addTargetUALimitedReleaseDetailFailure(error) {
    return {
      type: addTargetUALimitedReleaseDetailConstants.ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .addTargetUALimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(addTargetUALimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetUALimitedReleaseDetail(queryParams) {
  function removeTargetUALimitedReleaseDetailLoad() {
    return {
      type: removeTargetUALimitedReleaseDetailConstants.REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function removeTargetUALimitedReleaseDetailSuccess(data) {
    return {
      type: removeTargetUALimitedReleaseDetailConstants.REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function removeTargetUALimitedReleaseDetailFailure(error) {
    return {
      type: removeTargetUALimitedReleaseDetailConstants.REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .removeTargetUALimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(removeTargetUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              removeTargetUALimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateUALimitedReleaseDetail(queryParams) {
  function activateUALimitedReleaseDetailLoad() {
    return {
      type: activateUALimitedReleaseDetailConstants.ACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function activateUALimitedReleaseDetailSuccess(data) {
    return {
      type: activateUALimitedReleaseDetailConstants.ACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function activateUALimitedReleaseDetailFailure(error) {
    return {
      type: activateUALimitedReleaseDetailConstants.ACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .activateUALimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(activateUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(activateUALimitedReleaseDetailFailure(error?.toString()));
            reject(error);
          }
        );
    });
  };
}

function deactivateUALimitedReleaseDetail(queryParams) {
  function deactivateUALimitedReleaseDetailLoad() {
    return {
      type: deactivateUALimitedReleaseDetailConstants.DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deactivateUALimitedReleaseDetailSuccess(data) {
    return {
      type: deactivateUALimitedReleaseDetailConstants.DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deactivateUALimitedReleaseDetailFailure(error) {
    return {
      type: deactivateUALimitedReleaseDetailConstants.DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .deactivateUALimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deactivateUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateUALimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteUALimitedReleaseDetail(queryParams) {
  function deleteUALimitedReleaseDetailLoad() {
    return {
      type: deleteUALimitedReleaseDetailConstants.DELETE_UA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deleteUALimitedReleaseDetailSuccess(data) {
    return {
      type: deleteUALimitedReleaseDetailConstants.DELETE_UA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deleteUALimitedReleaseDetailFailure(error) {
    return {
      type: deleteUALimitedReleaseDetailConstants.DELETE_UA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteUALimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      uaLimitedReleasesDetailService
        .deleteUALimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deleteUALimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteUALimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const uaLimitedReleasesDetailActions = {
  getUALimitedReleaseDetail,
  createUALimitedReleaseDetail,
  editUALimitedReleaseDetail,
  addTargetUALimitedReleaseDetail,
  removeTargetUALimitedReleaseDetail,
  activateUALimitedReleaseDetail,
  deactivateUALimitedReleaseDetail,
  deleteUALimitedReleaseDetail,
};
